import { AutoMap } from "@automapper/classes";
import { AreaMapDTO } from "../services/dto/area-map.dto";
import { mapper } from "../tools/mapping/mapper";

export class AreaMap {
    @AutoMap()
    Id!: number;
    @AutoMap()
    Legend!: string;
    @AutoMap()
    Comment!: string;
    @AutoMap()
    JsonContent?: string;
    @AutoMap()
    BackgroundPicture?: string;
    @AutoMap()
    Data?: string;

    static mapFromJSON(json: AreaMapDTO): AreaMap {
        let map = new AreaMap;

        map = mapper.map(json, AreaMapDTO, AreaMap);

        return map;
    }
}